module.exports = __webpack_public_path__ + "static/media/toc-mockup-2.9faa2bdf.jpg";